import React from "react";
import Header from "./Components/Header";
import Hero from "./Components/Hero";
import Special from "./Components/Special";
import Product from "./Components/Product";
import Place from "./Components/Place";
import Blog from "./Components/Blog";
import Footer from "./Components/Footer";
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import '../node_modules/bootstrap/dist/js/bootstrap.bundle.min.js'
import { BrowserRouter, Routes, Route } from "react-router-dom";

function App() {
  return (

    <div>
      <BrowserRouter>
      <Header />
      <Routes>
      {/* <main className='main'> */}
      <Route path="/" element={<Hero/>} />
        <Route path="/Hero" element={<Hero/>} />
        <Route path="/Special" element={<Special/>} />
        <Route path="/Product" element={<Product/>} />
        <Route path="/Place" element={<Place/>} />
        <Route path="/Blog" element={<Blog/>} />
        {/* </main> */}
      </Routes>

       <Footer /> 
    </BrowserRouter>
    </div>
    /* <Header />
    <main className='main'>
    <Hero />
    <Special />
    <Product />
    <Place />
    <Blog />
    </main>
    <Footer /> */


  );
}

export default App;
